import React from "react";
import { View } from "react-native";
import { s } from "react-native-size-matters";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import Skeletons from "./Skeletons";
import { AppColors } from "../../utility/AppColors";

const StreamingPlateformComponentSkeleton = () => {
  const deviceSize = useDeviceSize();
  const styles = useStyles();

  return (
    <View style={{ justifyContent: "space-between", flexDirection: "row" }}>
      <View
        style={{
          backgroundColor: AppColors.purple_453B50,
          borderRadius: 10,
          padding:
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? 8
              : 24,
          width:
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? "100%"
              : "68%",
        }}
      >
        {/* Title */}
        <Skeletons
          width={
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? "60%"
              : "50%"
          }
          height={
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? "16px"
              : "24px"
          }
          style={{ borderRadius: s(4) }}
        />
        {/* Separator */}
        <Skeletons
          width="100%"
          height="1px"
          style={{
            borderRadius: s(4),
            marginTop:
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? 6
                : 12,
            marginBottom:
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? 6
                : 0,
          }}
        />
        {/* Description */}
        <Skeletons
          width="80%"
          height="14px"
          style={{ borderRadius: s(4), marginBottom: 12 }}
        />
        {/* Connected Platform Row (Simulating one platform) */}

        {/* Picker and Connect Button */}
        <View style={{ marginVertical: 10, gap: s(12), flexDirection: "row" }}>
          <View style={{ gap: s(6), flex: 1 }}>
            {/* Select Platform Label */}
            <Skeletons
              width="100px"
              height="14px"
              style={{ borderRadius: s(4) }}
            />
            {/* Picker */}
            <Skeletons
              width="100%"
              height="40px"
              style={{ borderRadius: s(4) }}
            />
          </View>
          {/* Connect Button */}
          <Skeletons
            width="80px"
            height="40px"
            style={{ borderRadius: s(4), alignSelf: "flex-end" }}
          />
        </View>
        {/* Add New Stream Link Button */}
        <Skeletons
          width={
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? "140px"
              : "160px"
          }
          height="36px"
          style={{ borderRadius: s(4), alignSelf: "flex-start" }}
        />
      </View>
    </View>
  );
};

const useStyles = CreateResponsiveStyle(
  {
    tooltipText: {
      marginBottom: 5,
    },
  },
  {
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.SM]: {},
    [DEVICE_SIZES.XS]: {},
  }
);

export default StreamingPlateformComponentSkeleton;
